import { FC } from "react";
import { IconPropsType } from ".";

export const Minus: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="9"
      height="2"
      viewBox="0 0 9 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="9" height="1.5" rx="0.75" fill={props.color} />
    </svg>
  );
};
